<script setup lang="ts">
import NoInputConfirmModal from '@/components/modal/NoInputConfirmModal.vue';
import { MODAL_TYPES, useModalStore } from '@/stores/modal';

interface Props {
  message: string;
  title?: string;
  confirmText?: string;
  messageClass?: string;
}

const props = defineProps<Props>();
const modalStore = useModalStore();

const handleClose = () => {
  modalStore.close(MODAL_TYPES.SIMPLE_ALERT);
};
</script>

<template>
  <NoInputConfirmModal
    :title="props.title || '알림'"
    :message="props.message"
    :message-class="props.messageClass"
    :modal-type="MODAL_TYPES.SIMPLE_ALERT"
    :confirm-text="props.confirmText || '확인'"
    :show-cancel="false"
    @confirm="handleClose"
  />
</template>
